import type {
  LearningSummaryType,
  LearningFragmentType,
  LearningKindType,
} from "@devforce/trailhead-client-gql";

export type LearningKindUnionType = `${LearningKindType}`;

export type LearningKindCollectionType = Extract<
  LearningKindUnionType,
  "MODULE" | "PROJECT" | "SUPERBADGE" | "TRAIL" | "TRAILMIX" | "LEARNINGPATH"
>;

export type LearningType = LearningSummaryType | LearningFragmentType;

export function pluralizeLearningCollectionType(
  type: LearningKindCollectionType
) {
  switch (type) {
    case "MODULE":
      return "modules";
    case "PROJECT":
      return "projects";
    case "SUPERBADGE":
      return "superbadges";
    case "TRAIL":
    case "LEARNINGPATH":
      return "trails";
    case "TRAILMIX":
      return "trailmixes";
    default:
      return type;
  }
}
export type LearningCollectionItem = {
  name: string;
  type: LearningKindCollectionType;
};
